import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'app/modules/react-redux';
import ErrorMessageView from 'app/components/ErrorMessageView';
import * as Actions from 'app/store/actions';
import { getSelectedLicenseGroupId, getIsSupportedRegion } from 'app/store/reducers';
import NotAvailablePage from 'app/main/not-available/NotAvailablePage';

type Status = 'loading' | 'success' | 'error';
type Props = {
	children: React.ReactNode;
};

// FIXME::WARNING::this component cannot contain `useTranslation`. For some reason React.Suspense is not stopping this from rendering.
const InitializeApp = ({ children }: Props) => {
	const dispatch = useDispatch() as any; // FIXME::why is `.then` not working?
	const isSupportedRegion = useSelector(getIsSupportedRegion);
	const [status, setStatus] = useState<Status>('loading');

	const selectedLicenseGroupId = useSelector(getSelectedLicenseGroupId) as
		| ReturnType<typeof getSelectedLicenseGroupId>
		| undefined; // HACK::use actual type here - assume never undefined within the wrapped app

	useEffect(() => {
		Promise.all([
			dispatch(Actions.getProfile()),
			dispatch(Actions.getLicenseGroups()),
			dispatch(Actions.getRegion()).then(() => dispatch(Actions.getCatalog()))
		])
			.then(() => {
				setStatus('success');
			})
			.catch(() => {
				setStatus('error');
			});
	}, [dispatch]);

	if (status === 'loading') {
		return <FuseSplashScreen />;
	}
	if (status === 'error') {
		return <ErrorMessageView />;
	}

	if (!isSupportedRegion) {
		return <NotAvailablePage />;
	}

	return <React.Fragment key={selectedLicenseGroupId}>{children}</React.Fragment>;
};

export default InitializeApp;
